import React, { useEffect } from "react";
import { generatePageHeaderName } from "@frameworks/salesjourney/components/Generic/TransparentHeader/TransparentHeader";
import { useNavigate } from "react-router-dom";
import { getQueryParameterName } from "@frameworks/salesjourney/utils/genericMethods";
import config from "@frameworks/salesjourney/config/domain";
var EmbeddedPage = function (props) {
    var navigate = useNavigate();
    var schemeCode = getQueryParameterName("schCode");
    var category = getQueryParameterName("cat");
    var route = category === "Other" ? "index" : "mutualfunds";
    var quoteUrl = "".concat(config.quotesBase, "quotes/rm-quotes/").concat(route, "/").concat(schemeCode, "?prefered_site=new");
    useEffect(function () {
        !!props.setHeaderLeftComponent &&
            props.setHeaderLeftComponent(React.createElement("div", { className: "d-flex align-items-center gap-4" },
                React.createElement("span", { onClick: function () {
                        return navigate("/dashboard/product-bouquet?productCode=56&categoryCode=261");
                    } },
                    React.createElement("i", { className: "edel-icon-left-arrow txt_white hand_cursor" })),
                generatePageHeaderName("Fund Details")));
    }, []);
    return (React.createElement("div", { className: "rm-quotes iframeoutersection" },
        React.createElement("iframe", { className: "iframeClass", src: quoteUrl })));
};
export default EmbeddedPage;
